import React from 'react';
import Form from 'react-bootstrap/Form';
import { Formik } from 'formik';
import * as yup from 'yup';
import { postPipelinesource } from "../../../../utils/event_handling";
import { userValidation } from "../../../../utils/common_utils";
import { PIPELINE_TEST_CONNECTION_MESSAGES_DBT } from "../../../../utils/constant";
import { faEye, faEyeSlash, faLock, faPlusCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InputGroup from 'react-bootstrap/InputGroup';
import { faTimesCircle } from '@fortawesome/fontawesome-free-regular';
import Alert from 'react-bootstrap/Alert';

const SpecificPipeline = (props) => {
    if (props.clickedValue === undefined) {
        return '';
    }

    const pipelineNames = props.clickedValue.map((elem) => elem.pipeline_name).join(",").split(",");

    return props.clickedValue.map((value, idx) => {
        const isExactMatch = props.clickedValue[idx]?.is_exact_match === "True" ||
            props.clickedValue[idx]?.is_exact_match === true ||
            props.clickedValue[idx]?.is_exact_match === "is_exact_match";

        return (
            <div className="dataset-partition-card" key={`dbt-core-pipeline-${idx}`}>
                {(props.pipelineToBeProcessed === "specifiedPipeline" && props.clickedValue.length > 1) ?
                    (<i onClick={props.removeSpecificPipeline.bind(null, idx)} className="icon-close text-danger">
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </i>) : ""}
                <div className="dp-card__content">
                    <span className="dp-card__label">Pipeline {idx + 1} to be processed</span>
                    <div className="form-row">
                        <Form.Group className="col-md-6 col-lg-4">
                            <Form.Label>Pipeline Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                className={(props.clickedValue[idx]["pipeline_name"] === "" ||
                                    props.clickedValue[idx]["pipeline_name"] === undefined ||
                                    (props.clickedValue[idx]["pipeline_name"] !== "" &&
                                        props.clickedValue[idx]["pipeline_name"] !== undefined &&
                                        pipelineNames.filter(x => x === props.clickedValue[idx]["pipeline_name"]).length > 1)) ?
                                    "form-control is-invalid" : "form-control"}
                                placeholder="DBT Project Name"
                                name={"specific_pipeline_name_" + (idx + 1)}
                                id={"specific_pipeline_name_" + (idx + 1)}
                                data-index={idx}
                                data-key={"pipeline_name"}
                                value={(props.clickedValue[idx]["pipeline_name"] === "" ||
                                    props.clickedValue[idx]["pipeline_name"] === undefined) ? "" :
                                    props.clickedValue[idx]["pipeline_name"]}
                                onChange={(e) => { props.changePipelineText(e) }}
                            />
                            {(props.clickedValue[idx]["pipeline_name"] === "" ||
                                props.clickedValue[idx]["pipeline_name"] === undefined) ?
                                <div className="error-text">Pipeline Name is required field</div> : ""}
                            {(props.clickedValue[idx]["pipeline_name"] !== "" &&
                                props.clickedValue[idx]["pipeline_name"] !== undefined &&
                                pipelineNames.filter(x => x === props.clickedValue[idx]["pipeline_name"]).length > 1) ?
                                <div className="error-text">Pipeline Name already added</div> : ""}
                            <Form.Text className="text-muted">
                                <Form.Check
                                    custom
                                    type="checkbox"
                                    label="Exact match only"
                                    id={"exact-match_" + (idx + 1)}
                                    data-index={idx}
                                    data-key={"is_exact_match"}
                                    name={"specific_exact_match_" + (idx + 1)}
                                    defaultChecked={isExactMatch}
                                    onChange={(e) => { props.handleExactMatch(e) }}
                                />
                            </Form.Text>
                        </Form.Group>
                    </div>
                </div>
            </div>
        );
    });
}

class DbtCore extends React.Component {
    constructor(props) {
        super(props);
        this.fill_details = this.fill_details.bind(this);
        this.postPipelinesource = postPipelinesource.bind(this);
        this.postDbtCoreData = this.postDbtCoreData.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.ChangesecretKeyIcon = this.ChangesecretKeyIcon.bind(this);
        this.handlePipelineChange = this.handlePipelineChange.bind(this);
        this.addSpecificPipeline = this.addSpecificPipeline.bind(this);
        this.removeSpecificPipeline = this.removeSpecificPipeline.bind(this);
        this.handleExactMatch = this.handleExactMatch.bind(this);
        this.changePipelineText = this.changePipelineText.bind(this);
        this.handleAuthenticationChange = this.handleAuthenticationChange.bind(this);
        this.state = {
            isChecked: true,
            hideSubmitButton: false,
            integration_data: this.props.integration_data,
            integration_data_edit: "",
            secretKeyType: 'password',
            secretKeyIcon: faEye,
            showPasswordField: true,
            pipelineToBeProcessed: "allPipeline",
            specificPipeline: [{ "pipeline_name": "", "is_exact_match": "False" }],
            dataset_processed_edit: true,
            updateData: false
        };
    }

    componentDidMount() {
        this.fill_details();

        if (this.props.ex_integration_details !== null) {
            this.setState({
                pipelineToBeProcessed: this.props.ex_integration_details[0]['integration_config']['pipelineToBeProcessed'] === undefined ? "allPipeline" : this.props.ex_integration_details[0]['integration_config']['pipelineToBeProcessed'],
                dataset_processed_edit: this.props.ex_integration_details[0]['integration_config']['pipelineToBeProcessed'] === undefined ? true : false,
                specificPipeline: this.props.ex_integration_details[0]['integration_config']['pipeline_name'],
            });
            if (this.props.ex_integration_details[0]['integration_config']['pipelineToBeProcessed'] === undefined) {
                this.setState({ specificPipeline: [] });
            }
        }
    }

    fill_details() {
        if (this.props.ex_integration_details !== undefined && this.props.ex_integration_details !== null) {
            let integration_data = this.state.integration_data;
            let auth_config = this.props.ex_integration_details[0]["auth_config"];

            integration_data.integration_name = this.props.ex_integration_details[0]["p_integration_name"];
            integration_data.integration_id = this.props.ex_integration_details[0]["p_integration_id"];
            integration_data.snowflake_account = auth_config["url"] || auth_config["snowflake_account"];
            integration_data.username = auth_config["username"];
            integration_data.password = auth_config["password"];
            integration_data.private_key = auth_config["private_key"];
            integration_data.private_key_pwd = auth_config["private_key_pwd"] || auth_config["private_key_password"];
            integration_data.warehouse = auth_config["warehouse"];
            integration_data.database = auth_config["database"];
            integration_data.schema = auth_config["schema"];
            integration_data.dbt_project_name = auth_config["dbt_project_name"];

            this.setState({
                integration_type: this.props.formType,
                integration_data_edit: integration_data,
                showPasswordField: !integration_data.private_key
            });
        }
    }

    changePipelineText(e) {
        let specificPipeline = [...this.state.specificPipeline];
        if (this.state.pipelineToBeProcessed === "specifiedPipeline") {
            specificPipeline[e.currentTarget.getAttribute("data-index")][e.currentTarget.getAttribute("data-key")] = e.currentTarget.value;
        }
        this.setState({ specificPipeline: specificPipeline, updateData: true });
    }

    handleExactMatch(e) {
        let specificPipeline = [...this.state.specificPipeline];
        specificPipeline[e.currentTarget.getAttribute("data-index")][e.currentTarget.getAttribute("data-key")] = e.target.checked === true ? "True" : "False";
        this.setState({ specificPipeline: specificPipeline });
    }

    handlePipelineChange(e) {
        if (e.target.value === "specifiedPipeline") {
            this.setState({ specificPipeline: [{ "pipeline_name": "", "is_exact_match": "is_exact_match" }] });
        }
        this.setState({ pipelineToBeProcessed: e.target.value });
    }

    addSpecificPipeline(e) {
        e.preventDefault();
        let validPipeline = true;
        let specificPipeline = this.state.specificPipeline;
        if (this.state.pipelineToBeProcessed === "specifiedPipeline") {
            for (let loop = 0; loop < specificPipeline.length; loop++) {
                if (specificPipeline[loop]['pipeline_name'] === "" || specificPipeline[loop]['pipeline_name'] === undefined) {
                    validPipeline = false;
                    break;
                }
            }
        }
        if (validPipeline === true) {
            this.setState((prevState) => ({
                specificPipeline: [...prevState.specificPipeline, { "pipeline_name": "", "is_exact_match": "is_exact_match" }]
            }));
        }
    }

    removeSpecificPipeline(idx) {
        let specificPipeline = [...this.state.specificPipeline];
        specificPipeline.splice(idx, 1);
        this.setState({ specificPipeline: specificPipeline, updateData: true });
    }

    toggleChange = () => {
        this.setState({ isChecked: !this.state.isChecked });
    }

    handleAuthenticationChange(authType, setFieldValue) {
        const showPasswordField = authType === "password";
        this.setState({ showPasswordField });
        if (showPasswordField) {
            setFieldValue("private_key", "");
            setFieldValue("private_key_pwd", "");
        } else {
            setFieldValue("password", "");
        }
    }

    postDbtCoreData(event) {
        let specificPipeline = this.state.specificPipeline;
        let validPipeline = true;

        let pipelineNameFilter = specificPipeline.map(function (elem) {
            return elem.pipeline_name;
        }).join(",");
        if (pipelineNameFilter !== "") {
            pipelineNameFilter = pipelineNameFilter.split(",");
        }

        if (this.state.pipelineToBeProcessed === "specifiedPipeline" && specificPipeline.length > 0) {
            specificPipeline.forEach(input => {
                if (input['pipeline_name'] === "" || input['pipeline_name'] === undefined) {
                    validPipeline = false;
                } else if (pipelineNameFilter.filter(x => x === input["pipeline_name"]).length > 1) {
                    validPipeline = false;
                }
            });
        } else {
            specificPipeline = [];
        }
        if (validPipeline === false) {
            return;
        }

        this.disableButton();
        const {
            integration_name, snowflake_account, username, password, private_key, private_key_pwd,
            warehouse, database, schema, dbt_project_name
        } = event;
        let dbtCore = {
            "p_integration_name": integration_name,
            "p_integration_id": this.state.integration_data.integration_id,
            "env_id": this.props.env_id,
            "auth_config": {
                "url": snowflake_account,
                "snowflake_account": snowflake_account,
                "username": username,
                "password": password,
                "private_key": private_key,
                "private_key_pwd": private_key_pwd,
                "warehouse": warehouse,
                "database": database,
                "schema": schema,
                "dbt_project_name": dbt_project_name
            },
            "integration_config": {
                "pipelineToBeProcessed": this.state.pipelineToBeProcessed,
                "pipeline_name": specificPipeline
            },
            "tenant_id": localStorage.getItem('team_id'),
            "integration_type": "dbt_core",
        };

        let default_message = PIPELINE_TEST_CONNECTION_MESSAGES_DBT[this.props.formType];
        this.props.closeTestConnection();
        this.props.setSubmitButton(true);
        this.props.setData(dbtCore, default_message);
        this.postPipelinesource(dbtCore);
    }

    getSchema() {
        return yup.object({
            integration_name: yup.string().min(1, "Name must be at least 1 characters").required("Pipelinesource Name is a required field").test(
                'Pipelinesource name test',
                'invalid Pipelinesource name',
                function test(value) {
                    let val = userValidation(value, "input");
                    return val;
                }
            ),
            snowflake_account: yup.string().required('host is a required field'),
            username: yup.string().required("username is a required field"),
            password: this.state.showPasswordField
                ? yup.string().required('Snowflake Password is a required field')
                : yup.string().nullable(),
            private_key: this.state.showPasswordField
                ? yup.string().nullable()
                : yup.string().required('Private Key is a required field'),
            private_key_pwd: yup.string(),
            warehouse: yup.string().required('warehouse is a required field'),
            database: yup.string().required('database is a required field'),
            schema: yup.string().required('schema is a required field'),
            dbt_project_name: yup.string().required('DBT Project Name is a required field'),
        });
    }

    disableButton() {
        this.setState({ hideSubmitButton: true });
    }

    ChangesecretKeyIcon() {
        if (this.state.secretKeyIcon.iconName === "eye") {
            this.setState({ secretKeyIcon: faEyeSlash, secretKeyType: "text" });
        } else {
            this.setState({ secretKeyIcon: faEye, secretKeyType: "password" });
        }
    }

    render() {
        let initial_values = {
            integration_name: '',
            snowflake_account: '',
            username: '',
            password: '',
            private_key: '',
            private_key_pwd: '',
            warehouse: '',
            database: '',
            schema: '',
            dbt_project_name: ''
        };

        let edit_integration = this.props.ex_integration_details !== null && this.props.ex_integration_details !== undefined;

        return (
            <>
                <Formik
                    validationSchema={this.getSchema()}
                    onSubmit={this.postDbtCoreData}
                    validateOnBlur={false}
                    initialValues={edit_integration === true ? this.state.integration_data_edit : initial_values}
                    enableReinitialize={true}>
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <div className="form-row">
                                <Form.Group controlId="integration_name" className="form-group col-md-6">
                                    <Form.Label>Pipeline Source Name <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" className="form-control" name="integration_name"
                                        value={values.integration_name === undefined ? '' : values.integration_name}
                                        onChange={handleChange} onBlur={handleBlur}
                                        isInvalid={errors.integration_name && touched.integration_name}
                                        placeholder="Pipeline Source Name" />
                                    <Form.Control.Feedback type="invalid">{touched.integration_name && errors.integration_name}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="snowflake_account" className="col-md-6">
                                    <Form.Label>Snowflake Host <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" className="form-control" name="snowflake_account"
                                        value={values.snowflake_account === undefined ? "" : values.snowflake_account}
                                        onChange={handleChange} placeholder="xy12345.us-east-1 or Snowflake URL"
                                        onBlur={handleBlur} isInvalid={errors.snowflake_account && touched.snowflake_account} />
                                    <Form.Control.Feedback type="invalid">{touched.snowflake_account && errors.snowflake_account}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="username" className="col-md-6">
                                    <Form.Label>Snowflake Username <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" className="form-control" name="username"
                                        value={values.username === undefined ? "" : values.username}
                                        onChange={handleChange} placeholder="Username"
                                        onBlur={handleBlur} isInvalid={errors.username && touched.username} />
                                    <Form.Control.Feedback type="invalid">{touched.username && errors.username}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="dbtCoreAuthentication" className="col-md-6">
                                    <Form.Label>Authentication <span className="text-danger">*</span></Form.Label>
                                    <div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                id="dbtCorePasswordAuth"
                                                name="dbtCoreAuthentication"
                                                className="custom-control-input"
                                                checked={this.state.showPasswordField === true}
                                                onChange={() => this.handleAuthenticationChange("password", setFieldValue)}
                                            />
                                            <label className="custom-control-label mb-1" htmlFor="dbtCorePasswordAuth">Password</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                id="dbtCorePrivateKeyAuth"
                                                name="dbtCoreAuthentication"
                                                className="custom-control-input"
                                                checked={this.state.showPasswordField === false}
                                                onChange={() => this.handleAuthenticationChange("private_key", setFieldValue)}
                                            />
                                            <label className="custom-control-label mb-1" htmlFor="dbtCorePrivateKeyAuth">Private key</label>
                                        </div>
                                    </div>
                                </Form.Group>

                                {this.state.showPasswordField ?
                                    <Form.Group controlId="password" className="col-md-6">
                                        <Form.Label>Snowflake Password <span className="text-danger">*</span></Form.Label>
                                        <InputGroup bsPrefix="icon-input-group">
                                            <i><FontAwesomeIcon icon={faLock} /></i>
                                            <Form.Control type={this.state.secretKeyType} className="form-control" name="password"
                                                value={values.password === undefined ? "" : values.password}
                                                onChange={handleChange} placeholder="Password"
                                                onBlur={handleBlur} isInvalid={errors.password && touched.password}
                                                autoComplete={this.props.autocomplete} />
                                            <Form.Control.Feedback type="invalid">{touched.password && errors.password}</Form.Control.Feedback>
                                            <i className="security-eye">
                                                <FontAwesomeIcon onClick={this.ChangesecretKeyIcon} icon={this.state.secretKeyIcon} className="security-eye" />
                                            </i>
                                        </InputGroup>
                                    </Form.Group>
                                    :
                                    <Form.Group controlId="private_key" className="col-md-12">
                                        <Form.Label>Private Key <span className="text-danger">*</span></Form.Label>
                                        <Form.Control as="textarea" rows={2} className="form-control" name="private_key"
                                            value={values.private_key === undefined ? "" : values.private_key}
                                            onChange={handleChange} placeholder="Enter Private Key"
                                            onBlur={handleBlur} isInvalid={errors.private_key && touched.private_key}
                                            autoComplete={this.props.autocomplete} />
                                        <Form.Control.Feedback type="invalid">{touched.private_key && errors.private_key}</Form.Control.Feedback>
                                    </Form.Group>
                                }

                                {this.state.showPasswordField === false ?
                                    <Form.Group controlId="private_key_pwd" className="col-md-6">
                                        <Form.Label>Private Key Passphrase</Form.Label>
                                        <Form.Control type="password" className="form-control" name="private_key_pwd"
                                            value={values.private_key_pwd === undefined ? "" : values.private_key_pwd}
                                            onChange={handleChange} placeholder="Private Key Passphrase"
                                            onBlur={handleBlur} isInvalid={errors.private_key_pwd && touched.private_key_pwd}
                                            autoComplete={this.props.autocomplete} />
                                        <Form.Control.Feedback type="invalid">{touched.private_key_pwd && errors.private_key_pwd}</Form.Control.Feedback>
                                    </Form.Group>
                                    : ""}

                                <Form.Group controlId="warehouse" className="col-md-6">
                                    <Form.Label>Warehouse <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" className="form-control" name="warehouse"
                                        value={values.warehouse === undefined ? "" : values.warehouse}
                                        onChange={handleChange} placeholder="Warehouse"
                                        onBlur={handleBlur} isInvalid={errors.warehouse && touched.warehouse} />
                                    <Form.Control.Feedback type="invalid">{touched.warehouse && errors.warehouse}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="database" className="col-md-6">
                                    <Form.Label>Database <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" className="form-control" name="database"
                                        value={values.database === undefined ? "" : values.database}
                                        onChange={handleChange} placeholder="Database"
                                        onBlur={handleBlur} isInvalid={errors.database && touched.database} />
                                    <Form.Control.Feedback type="invalid">{touched.database && errors.database}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="schema" className="col-md-6">
                                    <Form.Label>Schema <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" className="form-control" name="schema"
                                        value={values.schema === undefined ? "" : values.schema}
                                        onChange={handleChange} placeholder="Schema"
                                        onBlur={handleBlur} isInvalid={errors.schema && touched.schema} />
                                    <Form.Control.Feedback type="invalid">{touched.schema && errors.schema}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="dbt_project_name" className="col-md-6">
                                    <Form.Label>DBT Project Name <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" className="form-control" name="dbt_project_name"
                                        value={values.dbt_project_name === undefined ? "" : values.dbt_project_name}
                                        onChange={handleChange} placeholder="DBT Project Name"
                                        onBlur={handleBlur} isInvalid={errors.dbt_project_name && touched.dbt_project_name} />
                                    <Form.Control.Feedback type="invalid">{touched.dbt_project_name && errors.dbt_project_name}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="col-md-6">
                                    <Form.Label>Pipeline to be processed</Form.Label>
                                    <div>
                                        <div className="custom-control custom-radio custom-control-inline mt-1">
                                            <Form.Control type="radio" id="dbtCoreAllPipeline" name="dbtCoreAllPipeline"
                                                disabled={edit_integration === true && this.state.dataset_processed_edit === false ? true : false}
                                                checked={this.state.pipelineToBeProcessed === "allPipeline"}
                                                value="allPipeline" onChange={this.handlePipelineChange}
                                                className="custom-control-input" />
                                            <Form.Label className="custom-control-label" htmlFor="dbtCoreAllPipeline">All Pipelines</Form.Label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline mt-1">
                                            <Form.Control type="radio" id="dbtCoreSpecifiedPipeline" name="dbtCoreSpecifiedPipeline"
                                                disabled={edit_integration === true && this.state.dataset_processed_edit === false ? true : false}
                                                value="specifiedPipeline" onChange={this.handlePipelineChange}
                                                checked={this.state.pipelineToBeProcessed === "specifiedPipeline"}
                                                className="custom-control-input" />
                                            <Form.Label className="custom-control-label" htmlFor="dbtCoreSpecifiedPipeline">Specified Pipelines</Form.Label>
                                        </div>
                                    </div>
                                </Form.Group>

                                {edit_integration === true ?
                                    <div className="col-12 partition_alert_info">
                                        <Alert variant="warning">
                                            <p className="mb-0 alert-warning-text">
                                                <i className="mr-2"><FontAwesomeIcon icon={faInfoCircle} /></i>
                                                Current Metrics and all related information will be lost on modifying existing specified pipelines
                                            </p>
                                        </Alert>
                                    </div> : ""}

                                {this.state.pipelineToBeProcessed === "specifiedPipeline" ?
                                    <>
                                        <SpecificPipeline
                                            clickedValue={this.state.specificPipeline}
                                            pipelineToBeProcessed={this.state.pipelineToBeProcessed}
                                            changePipelineText={this.changePipelineText}
                                            removeSpecificPipeline={this.removeSpecificPipeline}
                                            handleExactMatch={this.handleExactMatch}
                                        />
                                        <a href="!#" onClick={this.addSpecificPipeline}>
                                            <i className="mr-1"><FontAwesomeIcon icon={faPlusCircle} /></i>Add Another Pipeline
                                        </a>
                                        <hr className="clearfix w-100" />
                                    </> : ""}

                                <div className="checkbox col-md-12" style={{ "padding": "10px 5px" }}>
                                    <Form.Label>
                                        <Form.Control type="checkbox" name="errorColumn"
                                            onChange={this.toggleChange} checked={this.state.isChecked} />
                                        <span className="checkbox-decorator"><span className="check"></span></span>
                                        Store Pipeline Issues and Errors in Qualdo
                                    </Form.Label>
                                </div>
                            </div>
                            <hr className="clearfix" />
                            <div className="text-right">
                                {this.props.showCancel ?
                                    <button type="button"
                                        onClick={() => this.props.ex_integration_details ? this.props.closeModal() : this.props.setPage(false)}
                                        className="btn btn-outline btn-grey btn-circle mr-2">
                                        Cancel
                                    </button> : ''}
                                <button type="submit" disabled={this.state.hideSubmitButton}
                                    className="btn btn-primary btn-circle mr-2">
                                    Test Connection
                                </button>
                            </div>
                        </Form>)}
                </Formik>
            </>
        );
    }
}

export default DbtCore;
